import { createSlice } from "@reduxjs/toolkit";
import { emptyDoctorObj } from "@/utils/constants";

import { ISliceCreateUser } from "@/shared/interfaces/patientPage";

const initialState: ISliceCreateUser = {
    selectedDoctor: emptyDoctorObj,
    doctorId: "",
};

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {
        setUserData: (state, action) => {
            state.selectedDoctor = action.payload;
        },
        resetDoctorData: state => {
            state.selectedDoctor = emptyDoctorObj;
        },
        updateUserData: (state, action) => {
            Object.assign(state.selectedDoctor, action.payload);
        },
        deleteAppointment: (state, action) => {
            const id = action.payload;
            state.selectedDoctor.appointments =
                state.selectedDoctor.appointments?.filter(
                    item => item._id !== id,
                );
        },
    },
});

export const {
    setUserData,
    resetDoctorData,
    updateUserData,
    deleteAppointment,
} = usersSlice.actions;
export default usersSlice.reducer;
